import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col px-4 gap-4 mt-4 w-full items-center" }
const _hoisted_3 = { class: "flex flex-row w-full p-0 mb-4" }
const _hoisted_4 = { class: "flex flex-col p-4 text-start border border-gray-300 rounded-md flex-1" }
const _hoisted_5 = { class: "flex flex-row gap-2 mb-2" }
const _hoisted_6 = { class: "flex flex-row gap-2 mb-2" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = { class: "ml-4 block p-4 text-center border border-gray-300 rounded-md flex-1" }
const _hoisted_9 = { class: "block p-4 text-center border border-gray-300 rounded-md flex-1" }
const _hoisted_10 = { class: "flex flex-row w-full p-0 flex-wrap mb-4" }
const _hoisted_11 = { class: "block p-4 text-center border border-gray-300 rounded-md flex-1" }
const _hoisted_12 = { class: "m-4 block w-full h-full flex-1" }
const _hoisted_13 = { class: "flex flex-col gap-2 border border-gray-300 rounded-md p-4" }
const _hoisted_14 = { class: "flex gap-2" }
const _hoisted_15 = { class: "cell-item" }
const _hoisted_16 = { class: "cell-item" }
const _hoisted_17 = { class: "cell-item" }
const _hoisted_18 = { class: "cell-item" }
const _hoisted_19 = { class: "cell-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_caret_bottom = _resolveComponent("caret-bottom")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_user = _resolveComponent("user")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_iphone = _resolveComponent("iphone")!
  const _component_location = _resolveComponent("location")!
  const _component_tickets = _resolveComponent("tickets")!
  const _component_office_building = _resolveComponent("office-building")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "w-full h-12 p-4 shadow-md" }, [
      _createElementVNode("span", { class: "text-large text-black text-bold font-600 mr-3" }, "Layout5")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm" }, "Default", -1)),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.value1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value1) = $event)),
            class: "block mb-4",
            type: "date",
            placeholder: "Pick a day"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              class: "mb-4 w-32",
              plain: true,
              onClick: _ctx.open
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Show message")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "mb-4 w-32",
              plain: true,
              onClick: _ctx.openVn
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("VNode")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "mb-4",
              onClick: _ctx.openMessageBox
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Click to open the Message Box")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              plain: "",
              onClick: _ctx.open1
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode(" Closes automatically ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              plain: "",
              onClick: _ctx.open2
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode(" Won't close automatically ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_badge, {
              value: 12,
              class: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("comments")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_badge, {
              value: 3,
              class: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("replies")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_badge, {
              value: 1,
              class: "item",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("comments")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_badge, {
              value: 2,
              class: "item",
              type: "warning"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("replies")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_badge, {
              value: 1,
              class: "item",
              color: "green"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("custom background")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown, {
              class: "m-2 w-32",
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { class: "clearfix" }, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createTextVNode(" comments ")),
                        _createVNode(_component_el_badge, {
                          class: "mark",
                          value: 12
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, { class: "clearfix" }, {
                      default: _withCtx(() => [
                        _cache[22] || (_cache[22] = _createTextVNode(" replies ")),
                        _createVNode(_component_el_badge, {
                          class: "mark",
                          value: 3
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _cache[20] || (_cache[20] = _createTextVNode(" Click Me ")),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_caret_bottom)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_upload, {
              "file-list": _ctx.fileList,
              "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
              class: "upload-demo",
              action: "https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15",
              multiple: "",
              "on-preview": _ctx.handlePreview,
              "on-remove": _ctx.handleRemove,
              "before-remove": _ctx.beforeRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed
            }, {
              tip: _withCtx(() => _cache[25] || (_cache[25] = [
                _createElementVNode("div", { class: "el-upload__tip" }, " jpg/png files with a size less than 500KB. ", -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Click to upload")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["file-list", "on-preview", "on-remove", "before-remove", "on-exceed"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Activity name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity zone" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.region,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.region) = $event)),
                    placeholder: "please select your zone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Zone one",
                        value: "shanghai"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Zone two",
                        value: "beijing"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity time" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 11 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date1,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.date1) = $event)),
                        type: "date",
                        placeholder: "Pick a date",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 2,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createElementVNode("span", { class: "text-gray-500" }, "-", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 11 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_time_picker, {
                        modelValue: _ctx.form.date2,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.date2) = $event)),
                        placeholder: "Pick a time",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Instant delivery" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.delivery,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.delivery) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity type" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.type) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        value: "Online activities",
                        name: "type"
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode(" Online activities ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, {
                        value: "Promotion activities",
                        name: "type"
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode(" Promotion activities ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, {
                        value: "Offline activities",
                        name: "type"
                      }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createTextVNode(" Offline activities ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, {
                        value: "Simple brand exposure",
                        name: "type"
                      }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createTextVNode(" Simple brand exposure ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Resources" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.form.resource,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.resource) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { value: "Sponsor" }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("Sponsor")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { value: "Venue" }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode("Venue")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Activity form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.desc,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.desc) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("Create")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createTextVNode("Cancel")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_tag, { type: "primary" }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("Tag 1")
                ])),
                _: 1
              }),
              _createVNode(_component_el_tag, { type: "success" }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createTextVNode("Tag 2")
                ])),
                _: 1
              }),
              _createVNode(_component_el_tag, { type: "info" }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createTextVNode("Tag 3")
                ])),
                _: 1
              }),
              _createVNode(_component_el_tag, { type: "warning" }, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createTextVNode("Tag 4")
                ])),
                _: 1
              }),
              _createVNode(_component_el_tag, { type: "danger" }, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createTextVNode("Tag 5")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_el_descriptions, {
              class: "margin-top",
              title: "With border",
              column: 3,
              border: ""
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("Operation")
                  ])),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_icon, {
                        style: _normalizeStyle(_ctx.iconStyle)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_user)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _cache[41] || (_cache[41] = _createTextVNode(" Username "))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _cache[42] || (_cache[42] = _createTextVNode(" kooriookami "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_icon, {
                        style: _normalizeStyle(_ctx.iconStyle)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_iphone)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _cache[43] || (_cache[43] = _createTextVNode(" Telephone "))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _cache[44] || (_cache[44] = _createTextVNode(" 18100000000 "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_icon, {
                        style: _normalizeStyle(_ctx.iconStyle)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _cache[45] || (_cache[45] = _createTextVNode(" Place "))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _cache[46] || (_cache[46] = _createTextVNode(" Suzhou "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_icon, {
                        style: _normalizeStyle(_ctx.iconStyle)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tickets)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _cache[47] || (_cache[47] = _createTextVNode(" Remarks "))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, { size: "small" }, {
                      default: _withCtx(() => _cache[48] || (_cache[48] = [
                        _createTextVNode("School")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_icon, {
                        style: _normalizeStyle(_ctx.iconStyle)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_office_building)
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _cache[49] || (_cache[49] = _createTextVNode(" Address "))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _cache[50] || (_cache[50] = _createTextVNode(" No.1188, Wuzhong Avenue, Wuzhong District, Suzhou, Jiangsu Province "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}